import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../shared';

import {OrganizationRoutingModule} from './organization-routing.module';
import {OrganizationContainer} from './containers/organization/organization.container';
import {OrganizationListPageContainer} from './containers/organization-list-page/organization-list-page.container';
import {CreateOrganizationPageContainer} from './containers/create-organization-page/create-organization-page.container';
import {OrganizationPendingComponent} from './components/organization-pending/organization-pending.component';
import {CreateOrganizationFormComponent} from './components/create-organization-form/create-organization-form.component';
import {OrganizationListComponent} from './components/organization-list/organization-list.component';
import {OrganizationListDialogContainer} from './containers/organization-list-dialog/organization-list-dialog.container';

import {FormModule} from '../vision/form';
import {InputModule} from '../vision/input';

@NgModule({
  imports: [
    SharedModule,
    OrganizationRoutingModule,
    ReactiveFormsModule,
    FormModule,
    InputModule
  ],
  declarations: [
    OrganizationContainer,
    OrganizationListPageContainer,
    CreateOrganizationPageContainer,
    OrganizationPendingComponent,
    CreateOrganizationFormComponent,
    OrganizationListComponent,
    OrganizationListDialogContainer
  ],
  exports: [
    OrganizationContainer,
    OrganizationListPageContainer,
    CreateOrganizationPageContainer,
    OrganizationPendingComponent,
    CreateOrganizationFormComponent,
    OrganizationListComponent,
    OrganizationListDialogContainer
  ],
  entryComponents: [
    OrganizationListDialogContainer
  ]
})

export class OrganizationModule {
}
